import Vue from 'vue';
import App from './App.vue';
import { router } from './router';
import './utils/common';
import { isDev } from './utils/common';
import * as mwx from '@/utils/common.js';

// import * as fundebug from 'fundebug-javascript';
// import FundebugVue from 'fundebug-vue';

Vue.config.productionTip = false;
import * as Sentry from '@sentry/vue';
if (!isDev) {
  window._Sentry = Sentry;
  let openReplay = false;
  try {
    Sentry.init({
      Vue,
      dsn:
        'https://0e2c8c0281dc3b9e03dcaffc0885e49c@o4509790235656192.ingest.us.sentry.io/4509796088610816',
      integrations: [
        new Sentry.BrowserTracing({
          // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
          tracePropagationTargets: [
            /^https:\/\/xingbaidesign\.com/
            // /^http:\/\/app\.book\.com/
          ]
        })
        // openReplay
        //   ? new Sentry.Replay({
        //       maskAllText: false,
        //       blockAllMedia: false
        //     })
        //   : null,
      ],
      // 2. 忽略常见无用报错
      ignoreErrors: [
        'object PromiseRejectionEvent',
        'Script error.',
        'AxiosError',
        'content risky',
        'Large Render Blocking Asset',
        'object ErrorEvent',
        'pollCheck fn',
        'object PromiseRejectionEvent',
        'Navigation cancelled',
        '获取图片信息失败',
        '订单不存在或已失效',
        '重试或联系商家客服',
        'fileToBase64 失败',
        '图片转换blobUrl失败',
        '图片转换base64失败',
        'FileReader encountered an error',
        '图片上传失败',
        'uploadImage fail',
        'Network Error',
        'Network error 0',
        'getImageInfo repeat fail',
        '[object Event]',
        '超时',
        /^Loading chunk .* failed$/,
        // 正则匹配：过滤超时相关错误
        /超时,index=\d+,activeCanvasIndex=\d+/,
        // 过滤未知的 promise rejection 错误
        /Event `Event` \(type=error\) captured as promise rejection/,
        'heic2any error:name=FullSizeRender',
        '图片格式转换失败',
        '[object Object]',
        'timeout',
        'Object captured as promise rejection with keys: code, data, message, requestId',
        'undefined',
        'Large Render Blocking Asset',
        '当前图片超过抠图限制',
        'insertCSS is not defined',
        "Cannot read properties of undefined (reading 'checkDpi')"
      ],

      // 3. 过滤所有未处理的 Promise rejection，不上报 Sentry
      beforeSend(event) {
        const mech = event.exception?.values?.[0]?.mechanism;
        if (!mech) return event;

        // 过滤噪音：Promise未处理、fetch、xhr、console
        const noisyTypes = ['onunhandledrejection', 'fetch', 'xhr', 'console'];
        if (noisyTypes.includes(mech.type)) {
          return null;
        }
        // ✅ 关键：真正过滤 console.error（两种判断方式都写上，最稳）
        const isConsoleError =
          mech.type === 'console' ||
          (mech.handled === false && mech.synthetic === true);

        if (isConsoleError) {
          return null;
        }

        return event;
      },

      // 4. 去重 & 防抖
      maxBreadcrumbs: 50,
      // Performance Monitoring
      tracesSampleRate: 0.1, //  Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: openReplay ? 0.1 : 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: openReplay ? 0.1 : 0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
    openReplay = true;
  } catch (error) {
    console.error(error);
  }
}
if (mwx.isWeChat()) {
  console.log('main初始化加载一次微信sdk>>>>');
  // 加载微信 JS SDK
  mwx.loadJsSdk('wx');
}

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app');
